import { StageTrigger } from '@templates/index';
import { useUiStore } from '@store/index';

export function TuningTrigger() {
  const setOpen = useUiStore((s) => s.setTuningOpen);
  return <StageTrigger label="TUNING" offsetLeft={12} onClick={() => setOpen(true)} />;
}
